import { render, staticRenderFns } from "./StatisticsGroupedCountsCard.vue?vue&type=template&id=3532eb49&"
import script from "./StatisticsGroupedCountsCard.vue?vue&type=script&lang=js&"
export * from "./StatisticsGroupedCountsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsGroupedCountsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports